module.exports = require("@swa-ui/core/src/GroupedRowList/GroupedRowList.module.scss");